import { render, staticRenderFns } from "./Noten.vue?vue&type=template&id=6ac927ea"
import script from "./Noten.vue?vue&type=script&lang=js"
export * from "./Noten.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports